module.exports = __webpack_public_path__ + "static/media/process-steps.41c258e9.svg";